








































import Vue from 'vue'
// import preColors from './json/pre_colors.json'
// import temColors from './json/tem_colors.json'
import statisticsList from "@/assets/json/statisticsList.json";

export default Vue.extend({
  props: {
    element: { type: String, default: '' },
    barShow: { type: Boolean, default: '' },
  },
  watch: {
    element(val) {
    }
  },
  computed: {
    colorList() {
      let key = ''
      const element = this.element
      if (element.startsWith('tem')) {
        key = 'tem'
      } else if (element === 'pre') {
        key = 'pre_1h'
      } else if (element === 'pre_0808' || element === 'pre_2020') {
        key = 'pre_any'
      } else {
        key = element
      }
      // @ts-ignore
      const detailStatJson = statisticsList[key].data
      detailStatJson.map((e: any) => {
        const value = e.value
        const rgbcolor = e.rgbcolor
        e.min = value[0]
        e.max = value[1]
        e.color = `rgba(${rgbcolor[0]}, ${rgbcolor[1]}, ${rgbcolor[2]}, 1.0)`
      })
      return detailStatJson

    },

  },
})
